import Marionette from "backbone.marionette";
import SelfModel from "models/selfModel.js";

import PwdInput from 'views/pwdInput/pwdInputView.js';

var selfModel = new SelfModel();

import PasswdTpl from "views/password/passwordView.ejs";
import CSS from "views/password/password.css";


import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({
    initialize: function() {

        this.listenTo(S.mApp, "pwd:check", function(data) {

            if (data.perc >= 4)
                $("#c_pwd").prop("disabled", false);
            else
                $("#c_pwd").prop("disabled", true);


        });
    },
    template: PasswdTpl,
    render: function() {
        this.$el.html(this.template(S.userInfo));
        this.pwdHolder.show(new PwdInput({
            lang: S.userInfo.attributes.lang
        }));
    },
    events: {
        "submit #userProfile": "send",
        "keyup #c_pwd": "confirmPwd",
        "click #back": "go_back"
    },
    send: function(ev) {
        ev.preventDefault();

        if ($("#pwd").val() !== $("#c_pwd").val()) {
            S.mApp.trigger("notify:error", {
                message: S.userInfo.attributes.lang.PWD_UNMATCH
            });

            return false;
        }

        selfModel.save({
            type: "password",
            value: $("#pwd").val()
        }, {
            beforeSend: T.useToken,
            success: function() {
                S.mApp.trigger("notify:success", {
                    message: S.userInfo.attributes.lang.PWD_CHANGED
                });
            },
            error: function() {
                S.mApp.trigger("notify:error", {
                    message: S.userInfo.attributes.lang.PWD_NOT_CHANGED
                });
            }
        });

        return false;
    },
    go_back: function(ev) {
        parent.history.back();
    },
    confirmPwd: function(ev) {
        if ($("#pwd").val() !== $("#c_pwd").val())
            $("#save").prop("disabled", true);
        else
            $("#save").prop("disabled", false);
    },
    regions: {
        "pwdHolder": "#pwdHolder"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/password/passwordView.js
// module id = 200
// module chunks = 0